import mq from '../utils/media-queries';

export default {
  controlElement: null,
  trigger: null,
  close: null,
  openFlag: 'search-is-visible',

  _bindEvents() {

    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.show();
    });

    this.close.addEventListener('click', (e) => {
      e.preventDefault();
      this.hide();
    });

    document.addEventListener('keydown', (e) => {
      if ( e.key == 'Escape' ) this.hide();
    });

    mq.onMaxWidth('nav', () => this.hide());
  },

  init() {
    this.controlElement = document.querySelector('#site-header');
    this.trigger = document.querySelector('#header-search-toggle');
    this.close = document.querySelector('#header-search-close');
    this._bindEvents();
  },

  show() {
    this.controlElement.classList.add(this.openFlag);
  },

  hide() {
    this.controlElement.classList.remove(this.openFlag);
  },

}

